import { render, staticRenderFns } from "./WinbackList.vue?vue&type=template&id=74de2454&scoped=true&"
import script from "./WinbackList.vue?vue&type=script&lang=js&"
export * from "./WinbackList.vue?vue&type=script&lang=js&"
import style0 from "./WinbackList.vue?vue&type=style&index=0&id=74de2454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74de2454",
  null
  
)

export default component.exports